/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from 'styled-components';
import HeadingWithShowAll from 'Components/globalSearch/components/HeadingWithShowAll';
import SectionHeading from 'Components/globalSearch/components/SectionHeading';
import {
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { selectIsPagination } from 'Selector/GlobalSearchResultsSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Tooltip } from 'antd';

import { StaffBuyerGroupData } from 'Types/GroupsTypes';
import {
  maxMobile,
  maxTablet,
  maxWidth,
  maxWidth1300,
  midTablet,
  minExtraLargeScreen,
  primaryFont, primaryHeadingColor, retina, secondaryFont, smMobile, textBlack, wLight, wMBold,
  wMLight,
} from 'Utils/utilsStyle';
import { UserOutlined } from '@ant-design/icons';
import { formatNumberWithCommas, GroupSlicerResultPage, valueToObject } from 'Utils/UtilityFunctions';
import { FEED_GILROY_ROUTE, SEARCH, SEARCH_ROUTE } from 'Utils/Constants';
import { actions as flurryActions } from 'Slice/HelperSlice';
import classNames from 'classnames';
import { SearchResultsRouteState } from 'Pages/search/GlobalSearchResults';
import AddCompanyLimitPopup from '../modal/AddCompanyLimitPopup';
import BuyerGroupSkeleton from '../skeleton/BuyerGroupSkeleton';
import BuyerGroupCard from './BuyerGroupCard';
import SearchBuyerGroupSkeletonBlock from '../skeleton/SearchBuyerGroupSkeltonBlock';

type Props = {
  heading?: string,
  buyerGroupsCollection?: StaffBuyerGroupData[],
  loading?: boolean,
  showLoaderForLessResults?: boolean,
  numberOfLoaderForLessResults?: number,
  buyerGroupCount?: StaffBuyerGroupData[],
  count?: number,
  query?: string,
  setGroupTop?: (a: string) => void
  inGlobalSearch?: boolean,
  isPaginationOverride?: boolean,
} & typeof defaultProps;

const defaultProps = {
  heading: '',
  loading: false,
  buyerGroupsCollection: [] as StaffBuyerGroupData[],
  showLoaderForLessResults: false,
  numberOfLoaderForLessResults: 0,
  buyerGroupCount: [] as StaffBuyerGroupData[],
  count: 0,
  query: '',
  inGlobalSearch: false,
  setGroupTop(a: string) { },
};

const StyleWrapper = styled.div`
  .buyers-row {
   .buyers-card-item {
    height: auto;
   }
  }
`;

const BuyerGroupFooterDiv = styled.div`
&.searchBuyerGroup {
  padding-top:6px;
  .footer-heading {
    cursor: pointer;
    width: 90%;
    color: ${textBlack};
    text-align: center;
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMLight};
    line-height: 18px;
    letter-spacing: -0.52px;
    margin-bottom: 2px;
    @media all and (min-width: ${minExtraLargeScreen}) {
      font-size: 20px;
      line-height: 22px;
      letter-spacing: -0.746px;
    }
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      line-height: 18px;
      letter-spacing: -0.52px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 14px;
      line-height: 16px;
      letter-spacing: -0.414px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: -0.593px;
    }
  }
  @media all and (max-width: ${smMobile}) {
    padding-top: 4px;
  }
}
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top:12px;
    text-align: center;
    .footer-heading {
      width: 90%;
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      line-height: 24px;
      color: ${primaryHeadingColor};
      font-size: 20px;
    }
    .buyer-group-members-div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      @media all and (min-width: ${midTablet}) and (max-width: ${maxWidth1300}) {
        display: inline-block;

      }
      .anticon-user {
        svg {
          height: 10px;
          width: 16px;
          min-width: 16px;
        }
      }
    }
`;

const MembersText = styled.span`
&.globalSearchText {
  max-width: fit-content;
  cursor: pointer;
  color: ${primaryHeadingColor};
  text-align: center;
  font-family: ${primaryFont};
  font-size: 14px;
  font-weight: ${wLight};
  line-height: 16px;
  letter-spacing: -0.27px;
  padding-left: 0px;
  margin-left: 2px;
  @media all and (min-width: ${minExtraLargeScreen}) {
    font-size: 16px;
    line-height: 18px;
    letter-spacing: -0.387px;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.27px;
  }
  @media all and (max-width: ${maxTablet}) {
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.211px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.195px;
  }
}
max-width: 40%;
font-weight: ${wMBold};
font-size: 14px;
line-height: 28px;
color:${(props) => props.color};
padding-left: 5px;
`;

const BuyerGroupsSection = function BuyerGroupsSection(props: Props) {
  const [searchParams] = useSearchParams();
  const extendedSections = ['person', 'company', 'group', 'article'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);
  const isPaginationFromStore: boolean = useSelector(selectIsPagination);
  const slicerGroupNumber: number = GroupSlicerResultPage();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const {
    heading, buyerGroupsCollection, loading,
    showLoaderForLessResults,
    numberOfLoaderForLessResults,
    buyerGroupCount,
    count, query, setGroupTop, inGlobalSearch, isPaginationOverride,
  } = props;
  const isPagination = typeof isPaginationOverride === 'boolean'
    ? isPaginationOverride
    : isPaginationFromStore;
  const host = window.location.href;
  const formattedCount = formatNumberWithCommas(count);
  const location = useLocation();
  const { state } = location as { state: SearchResultsRouteState };
  const previousPath = (state)?.previousPath ?? FEED_GILROY_ROUTE;

  const createGroupRoute = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('searchPage_buyerGroups_see_all_clicked', 0, {
        host,
      }),
    ));
    window.scrollTo(0, 0);
    setGroupTop('group');
    return navigate(`${pathname}?query=${query}&extend=group`, { state: { enableBackButton: true, previousPath } });
  };

  const navigateToSearchResult = () => {
    const path = `${SEARCH_ROUTE}${query}`;
    navigate(path, {
      state: isDetailedSearch ? { enableBackButton: true, previousPath } : { previousPath },
    });
  };

  const loadersArray = [];
  if (showLoaderForLessResults) {
    for (let i = 0; i < numberOfLoaderForLessResults; i += 1) {
      loadersArray.push(
        <Col span={6} className="gutter-row">
          <BuyerGroupSkeleton border />
        </Col>,
      );
    }
  }

  return (

    buyerGroupsCollection.length > 0 || loading ? (
      <StyleWrapper>
        <AddCompanyLimitPopup />
        {
          loading && !isDetailedSearch
            ? (
              <SearchBuyerGroupSkeletonBlock
                sliceFlag={!isDetailedSearch}
                inGlobalSearch={inGlobalSearch}
              />
            )
            : (
              <>
                <div>
                  <HeadingWithShowAll
                    inGlobalSearch={inGlobalSearch}
                    isShowAllHidden={isDetailedSearch ? true
                      : buyerGroupCount && buyerGroupCount.length <= slicerGroupNumber}
                    leftHeading={(
                      <SectionHeading customClassName="global-search-heading">{`${heading} (${formattedCount})`}</SectionHeading>)}
                    onClick={createGroupRoute}
                    onSeelessClick={navigateToSearchResult}
                    isDetailedSearch={isDetailedSearch}
                  />
                  <Row
                    gutter={[{
                      xs: 16, lg: 40, md: 32, sm: 32,
                    }, 16]}
                    className={classNames('Grid-width-row', {
                      gridUpdated: inGlobalSearch,
                    })}
                  >
                    {buyerGroupsCollection?.map((group) => (
                      <Col span={6} xs={12} md={4} lg={4} sm={4} className="gutter-row h-auto">
                        <BuyerGroupCard
                          key={group.groupId}
                          groupId={group.groupId}
                          groupName={group.groupName}
                          groupPersona={group.groupPersonality}
                          persons={group.persons}
                          companies={group.companyLogos}
                          members={group.personsCount}
                          isShared={group.groupShared}
                          sharedBy={group.sharedByFirstName}
                          isSearchPage={pathname.includes(SEARCH)}
                          inGlobalSearch={inGlobalSearch}
                        />
                        <BuyerGroupFooterDiv className={classNames(
                          { searchBuyerGroup: inGlobalSearch },
                        )}
                        >
                          <Tooltip
                            trigger="hover"
                            placement="top"
                            getPopupContainer={(e: HTMLElement) => e}
                            className="triggers-bullet-tooltip person-designation-tip"
                            color="#fff"
                            title={group.groupName}
                            arrow={false}
                          >
                            <span className="footer-heading text-truncate-one-line">{group.groupName}</span>
                          </Tooltip>
                          {group.matched_companies?.count || group.matched_persons?.count ? (
                            <div className="w-100">
                              {group.matched_persons?.count === 0 ? (
                                <div className="buyer-group-members-div">
                                  {!inGlobalSearch && (
                                    <UserOutlined />
                                  )}
                                  <MembersText
                                    className={classNames('text-truncate', {
                                      globalSearchText: inGlobalSearch,
                                    })}
                                    color={inGlobalSearch ? undefined : '#52C41A'}

                                  >
                                    {`${group.matched_companies?.count ?? 0} ${group.matched_companies?.content ?? ''}`}
                                  </MembersText>
                                  <MembersText
                                    className={classNames(
                                      { globalSearchText: inGlobalSearch },
                                    )}
                                    color={inGlobalSearch ? undefined : '#808080'}
                                  >
                                    members
                                  </MembersText>
                                </div>
                              ) : group.matched_companies?.count ? (
                                <div className="buyer-group-members-div">
                                  <MembersText
                                    className={classNames('text-truncate', {
                                      globalSearchText: inGlobalSearch,
                                    })}
                                    color={inGlobalSearch ? undefined : '#52C41A'}
                                  >
                                    {`${group.matched_companies?.count} ${group.matched_companies?.content}`}
                                  </MembersText>
                                  <MembersText
                                    className={classNames(
                                      { globalSearchText: inGlobalSearch },
                                    )}
                                    color={inGlobalSearch ? undefined : '#808080'}
                                  >
                                    members
                                  </MembersText>
                                </div>
                              ) : (
                                <div className="buyer-group-members-div">
                                  <MembersText
                                    className={classNames(
                                      { globalSearchText: inGlobalSearch },
                                    )}
                                    color={inGlobalSearch ? undefined : '#52C41A'}
                                  >
                                    {group.matched_persons?.count !== 1
                                      ? `${group.matched_persons?.count ?? 0} people named` : '1 person named'}

                                  </MembersText>
                                  <MembersText
                                    className={classNames('text-truncate', {
                                      globalSearchText: inGlobalSearch,
                                    })}
                                    color={inGlobalSearch ? undefined : '#808080'}
                                  >
                                    {group.matched_persons?.content || ''}
                                  </MembersText>
                                </div>
                              )}
                            </div>
                          ) : null}
                        </BuyerGroupFooterDiv>
                      </Col>
                    ))}
                    {loading && !inGlobalSearch ? loadersArray : null}
                  </Row>
                </div>
                {isDetailedSearch && isPagination
                  && <SearchBuyerGroupSkeletonBlock inGlobalSearch={inGlobalSearch} />}

              </>
            )
        }
      </StyleWrapper>
    ) : (
      null
    )
  );
};

BuyerGroupsSection.defaultProps = defaultProps;
export default BuyerGroupsSection;